import { render } from "./ManageUsers.vue?vue&type=template&id=70803178&scoped=true"
import script from "./ManageUsers.vue?vue&type=script&lang=js"
export * from "./ManageUsers.vue?vue&type=script&lang=js"

import "./ManageUsers.vue?vue&type=style&index=0&id=70803178&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-70803178"]])

export default __exports__